import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ZimbabweFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16301'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16301)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 1.86667H20V0H0V1.86667Z'
					fill='#369D0C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V12.1333H0V14Z'
					fill='#369D0C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 5.59994H20V3.73328H0V5.59994Z'
					fill='#369D0C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2667H20V8.40002H0V10.2667Z'
					fill='#369D0C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 8.39998H20V5.59998H0V8.39998Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73337H20V1.8667H0V3.73337Z'
					fill='#FFD40E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 12.1334H20V10.2667H0V12.1334Z'
					fill='#FFD40E'
				/>
				<path
					d='M8.39739 7L-0.21939 13.3333H-0.286458V0.666667H-0.219391L8.39739 7Z'
					fill='white'
					stroke='#262626'
					strokeWidth='1.33333'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2.85751 7.90996L1.45803 8.88767L1.97439 7.28116L0.593095 6.27892L2.31171 6.26375L2.85751 4.66663L3.40332 6.26375L5.12194 6.27892L3.74064 7.28116L4.257 8.88767L2.85751 7.90996Z'
					fill='url(#paint0_linear_2332_16301)'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_16301'
					x1='0.476562'
					y1='4.66663'
					x2='0.476562'
					y2='9.33329'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#F12F1F' />
					<stop
						offset='1'
						stopColor='#DE2010'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default ZimbabweFlagIcon;
